<template>
    <Modal
        id="add-signature-document-modal"
        ref="add-signature-document-modal"
        v-model:open="open"
        title="add_signature_document"
        width="xl"
        @cancel="cancel"
    >
        <FileUploadButton
            title="asset_signature_document"
            accept=".pdf"
            :file-name="modelValue?.name"
            :url="modelValue?.url"
            @submit="onSignatureDocumentUpload"
            @delete="onSignatureDocumentDelete"
        />
        <SelectField
            v-model="modelValue.lang"
            :label="$t('language')"
            name="signature_document_lang"
            :required="true"
            :options="languages"
        />
        <TextField
            v-if="modelValue?.url"
            v-model="modelValue.signature_legal_notice"
            name="asset_signature_document_description"
            label="asset_signature_document_description"
            help="help_asset_signature_document_description"
            :rows="3"
            :required="false"
        />

        <template #actions>
            <button
                class="btn bg-primary-accent-500 text-white"
                @click="submit"
            >
                {{ $t('Create') }}
            </button>
        </template>
    </Modal>
</template>
<script setup lang="ts">
import { Modal } from '@src/components'
import SelectField from '@src/components/SelectField.vue'
import TextField from '@src/components/TextField.vue'
import { EmissionSignatureDocument } from '@src/types'
import { UploadFileResponse } from '@src/utils/api/s3'
import { useLanguageStore } from '@src/utils/stores/languages'
import { useVModels } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { toRefs } from 'vue'
import FileUploadButton from '../actions/FileUploadButton.vue'

const props = defineProps<{
    open: boolean
    modelValue: EmissionSignatureDocument | null
}>()

const { modelValue } = toRefs(props)

const emit = defineEmits([
    'update:modelValue',
    'update:open',
    'cancel',
    'submit',
])

const { open } = useVModels(props, emit)

const languageStore = useLanguageStore()
const { languages } = storeToRefs(languageStore)

const cancel = () => {
    emit('cancel')
}

const submit = () => {
    emit('submit', modelValue.value)
}

const onSignatureDocumentUpload = (
    response: UploadFileResponse,
    fileName: string
) => {
    if (modelValue.value) {
        modelValue.value.upload_key = response.key
        modelValue.value.url = response.temp_storage_url
        modelValue.value.name = fileName
    }
}

const onSignatureDocumentDelete = () => {
    if (modelValue.value) {
        modelValue.value.name = null
        modelValue.value.upload_key = null
        modelValue.value.lang = 'de'
    }
}
</script>
